import { render, staticRenderFns } from "./VerificationSetting.vue?vue&type=template&id=79d3e5c4&scoped=true"
import script from "./VerificationSetting.vue?vue&type=script&lang=js"
export * from "./VerificationSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d3e5c4",
  null
  
)

export default component.exports